import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class ContractsRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * create a contract
   * @param payload 
   */
  createContract(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/prime`;
    return this.http.post(url, payload);
  }

  /**
   * Get contract information
   * @param id company id
   * @param payload optional content
   */
  getContract(id, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${id}${query}`;
    return this.http.get(url);
  }

  /**
   * edit a contract
   * @param payload 
   */
  editContract(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${id}`;
    return this.http.patch(url, payload);
  }

  /**
   * Get list of contract types
   * @param payload 
   */
  getContractTypes(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/types${query}`;
    return this.http.get(url);
  }

  /**
   * invite users to team
   */
  inviteToContract(id, type, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${id}/users/${type}`;
    return this.http.post(url, payload);
  }

  /**
   * Get list of users from a contract
   * @param id contract id
   * @param type user types
   * @param payload optional content
   */
  getContractUsers(id, payload = {}) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${id}/users${query}`;
    return this.http.get(url);
  }

  /**
   * Get list of contract permissions
   * @param id contrac id
   */
  contractPermissions(id) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${id}/permissions`;
    return this.http.get(url);
  }

  /**
   * Get list of contract permissions
   * @param id contrac id
   */
  lookup(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.lookup}${query}`;
    return this.http.get(url);
  }

  updateContractSubmitterUser(contractId, userId, payload, type) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/users/${userId}/${type}`;
    return this.http.put(url, payload);
  }

  removeContractUser(contractId, userId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/users/${userId}`;
    return this.http.delete(url);
  }

  getListByParentId(options) {
    const payload = this.helpers.queryOptions(options);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/children${payload}`;
    return this.http.get(url);
  }

  getSettingsSection(contractDefinition) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractDefinition}/settings/daily_log_setup/sections`;
    return this.http.get(url);
  }

  getTeammateById(contractId, temmateId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/users/${temmateId}`;
    return this.http.get(url);
  }



  getDonwloadDailyStatus(contractDefinition, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractDefinition}/daily_status/download`;
    return this.http.get(url, payload).toPromise();
  }

  /**
 * Toggle section value
 * @param contractId  id of contract
 * @param section section to be affected
 * @param payload request options
 */
  storeSectionToggle(contractId, section, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/settings/daily_log_setup/${section}/toggle`;
    return this.http.post(url, payload);
  }

  getQuestionnaireSettings(contractId, type) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/settings/daily_log_setup/${type}`;
    return this.http.get(url);
  }

  getWalkthroughSettingSections(contractDefinition) {
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractDefinition}/settings/contract_walkthrough_setup/sections`;
    return this.http.get(url);
  }

  storeWalkthroughSettingToggle(contractId, section, payload) {
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractId}/settings/contract_walkthrough_setup/${section}/toggle`;
    return this.http.post(url, payload);
  }

  getWalkthroughQuestionnaireSettings(contractId, type) {
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractId}/settings/contract_walkthrough_setup/${type}`;
    return this.http.get(url);
  }

  storeQuestionnaireQuestions(contractId, section, payload) {
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractId}/settings/daily_log_setup/${section}`;
    return this.http.put(url, payload);
  }

  storeQuestionnairWalkeQuestions(contractId, section, payload) {
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractId}/settings/contract_walkthrough_setup/${section}`;
    return this.http.put(url, payload);
  }

  getSafeProxListworkers(contractId, payload) {
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractId}/workers`;
    return this.http.get(url, payload);
  }

  runContractSafeProxReport(contractId, workerId, payload) {
    const params = this.helpers.queryOptions(payload)
    const _action = this.config.services.contracts;
    const url = `${this.config.baseUrl}/v2/${_action}/${contractId}/workers/${workerId}/safeprox${params}`;
    return this.http.post(url, payload);
  }

}
